import RichText from '~/components/ui/RichText.vue';
export default defineComponent({
  name: 'BlockTwoColumnsImageText',
  components: {
    RichText: RichText
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var getItemTitle = function getItemTitle(item) {
      return item === null || item === void 0 ? void 0 : item.title;
    };
    return {
      getItemTitle: getItemTitle
    };
  }
});